import FlashLib from 'flashlib';
import ControllerSounds, { eSoundType } from '../sounds/controllerSounds';
import Event from '../../utils/event';

export default class ControllerSwitch extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);

    this.interactive = true;
    this.buttonMode = true;
    this.enabled = false;

    this.on('mouseover', this.onOver, this);
    this.on('mouseout', this.onOut, this);
    this.on('mousedown', this.onDown, this);
    this.on('mouseup', this.onUp, this);

    this.on('pointerdown', this.onDown, this);
    this.on('pointerup', this.onUp, this);
    this.on('pointerupoutside', this.onOut, this);

    this.on('pointertap', this.onClick, this);

    this.onSwitchEvent = new Event();
  }

  onOver() {
    this.goToFrame(this.enabled ? 5 : 2);
  }

  onOut() {
    this.goToFrame(this.enabled ? 4 : 1);
  }

  onDown() {
    this.goToFrame(this.enabled ? 6 : 3);
  }

  onUp() {
    this.goToFrame(this.enabled ? 4 : 1);
  }

  onClick() {
    this.enabled = !this.enabled;
    this.goToFrame(this.enabled ? 4 : 1);
    this.onSwitchEvent.call(this.enabled);
    ControllerSounds.playSound(eSoundType.EST_CLICK);
  }

  setEnabled(value) {
    this.enabled = value;
    this.goToFrame(this.enabled ? 4 : 1);
  }

  addEventListenerSwitched(callback) {
    this.onSwitchEvent.add(callback);
  }
}
